import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import { SectionShell } from "@/components/admin/SectionShell";

export const Route = createFileRoute("/admin/marketing")({
  head: () => seoHead({ title: "Marketing | Admin Shopping do Bem", description: "Área administrativa de marketing.", noindex: true }),
  component: MarketingLayout,
});

function MarketingLayout() {
  return <SectionShell title="Marketing" description="Notificações, banners, e-mail, WhatsApp e ações especiais" />;
}
